import { AbstractService } from './abstract-service.service';
import { HttpClient } from '@angular/common/http';

export abstract class AiChatBaseService extends AbstractService {
    constructor(protected httpClient: HttpClient) {
        super(httpClient);
    }
}
